import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function MouseIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M6 22.7646C6.00546 27.6355 9.95272 31.5827 14.8235 31.5882H17.1764C22.0472 31.5827 25.9944 27.6355 25.9999 22.7646V13.9411H18.2694C18.0052 14.9789 17.0708 15.7053 15.9999 15.7053C14.9291 15.7053 13.9947 14.9789 13.7305 13.9411H6V22.7646Z"
        fill="currentColor"
      />
      <path
        d="M14.8237 8.64722V13.3531C14.8237 14.0029 15.3505 14.5296 16.0002 14.5296C16.65 14.5296 17.1766 14.0029 17.1766 13.3531V8.64722C17.1766 7.99746 16.65 7.47076 16.0002 7.47076C15.3505 7.47076 14.8237 7.99746 14.8237 8.64722Z"
        fill="currentColor"
      />
      <path
        d="M18.3529 8.64708V12.7647H26V9.82354C25.9945 4.95272 22.0473 1.00553 17.1765 1H16.5882V6.37766C17.6239 6.64507 18.3489 7.57744 18.3529 8.64708Z"
        fill="currentColor"
      />
      <path
        d="M15.4121 6.37793C14.3764 6.64534 13.6515 7.57782 13.6475 8.64746V8.99219L9.87402 12.7646H7.41992L15.4121 4.77246V6.37793ZM13.6465 12.7646H11.5371L13.6465 10.6553V12.7646ZM15.4121 3.10938L6 12.5215V10.0674L15.0674 1H15.4121V3.10938ZM6.14746 8.25586C6.80692 4.63816 9.63815 1.80689 13.2559 1.14746L6.14746 8.25586Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
